const fetchErrorMixin = {
  data: () => ({
  }),

  methods: {
    fetchError(error) {
      let message = 'error';

      if (error.response && error.response.data.message) {
        message = error.response.data.message;
      }

      return message;
    },
  },
};

export default fetchErrorMixin;
